var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypcnArrowBackOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82081 11.402C3.77806 9.94364 4.96106 9.48572 6.41648 9.36964V10.2079C6.41648 10.5194 6.53781 10.8122 6.75831 11.0327C7.19931 11.4737 7.96989 11.4708 8.40506 11.0356L12.076 7.41489C12.1311 7.36061 12.1749 7.29591 12.2047 7.22456C12.2346 7.1532 12.25 7.07662 12.25 6.99927C12.25 6.92191 12.2346 6.84533 12.2047 6.77397C12.1749 6.70262 12.1311 6.63792 12.076 6.58364L8.40798 2.96522C7.96814 2.52481 7.19873 2.52422 6.75773 2.96581C6.53781 3.18631 6.41648 3.47914 6.41648 3.79064V4.78464C3.72206 5.32889 1.74981 7.69956 1.74981 10.499V11.0823C1.74948 11.208 1.78982 11.3305 1.86481 11.4314C1.93979 11.5323 2.04541 11.6063 2.16589 11.6422C2.28636 11.6782 2.41524 11.6742 2.53327 11.6309C2.65131 11.5876 2.75217 11.5073 2.82081 11.402ZM6.98639 8.17264C5.69898 8.20531 4.28089 8.40247 3.04423 9.40989C3.26743 8.47651 3.77349 7.63485 4.49322 7.00002C5.21295 6.36518 6.1112 5.96815 7.06514 5.86322C7.35914 5.83056 7.58314 5.83289 7.58314 5.83289V3.79297L10.8358 6.99897L7.58314 10.2073V8.16622L6.98639 8.17264Z",
    fill: "#469B12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnArrowBackOutline);
export default __webpack_public_path__ + "static/media/typcn_arrow-back-outline.7a97c0fdd980946b5124b88215670cd0.svg";
export { ForwardRef as ReactComponent };